// extracted by mini-css-extract-plugin
export default {"modal":"iQ7q6eLCLF","modal-absolute":"EDYvaSaauW","modalAbsolute":"EDYvaSaauW","modal-inline":"CzoE0J8htX","modalInline":"CzoE0J8htX","title-section":"+fJVZjBh0y","titleSection":"+fJVZjBh0y","title":"R9-WB4epSb","logo":"ujYw1l7+gb","line":"PTmvrVlCIw","body":"n0AhWVDzHV","message":"_4UGcSZM-bJ","control-bar":"zwwbclHtA7","controlBar":"zwwbclHtA7","shadow":"dCmc4bVkAe"};
    if(module.hot) {
      // 1643570370812
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  